module.exports = __webpack_public_path__ + "img/practical-go-lessons-book9.c27ca2e5.jpg";